// extracted by mini-css-extract-plugin
export default {"container":"ForceChangePassword_container__xxp27"};